import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import { Link } from 'gatsby-theme-material-ui';

export const SiteHeaderImage = () => (
  <Link to={'/'} title={'Home'}><StaticImage
    src={'../../images/logos/driveNinjaHeader.png'}
    alt="Drive Ninja Logo"
    height={50}
  />
  </Link>
);
